module.exports = __webpack_public_path__ + "static/media/Site_Bakery.59aac8c7.jpg";